import React from 'react';
import { Button, Tooltip } from 'antd';
import type { ButtonProps } from 'antd';

interface ActionButtonProps extends ButtonProps {
	tooltip: string;
	icon: React.ReactNode;
}

export function ActionButton({ tooltip = '', icon = null, ...rest }: Readonly<ActionButtonProps>) {
	return (
		<Tooltip title={tooltip} overlayStyle={{ position: 'fixed' }}>
			<Button type="link" icon={icon} {...rest} />
		</Tooltip>
	);
}
